module.exports = __webpack_public_path__ + "static/media/page05_and06_back.dcf7fccf.png";